<script lang="ts">
  import filtersService from './utils/filters-service.svelte';
  import type { Theatre } from './types';
  import MultiCheckboxInput from './MultiCheckboxInput.svelte';
  import SearchInput from './SearchInput.svelte';
  import TimeRangeInput from './TimeRangeInput.svelte';

  type Props = {
    dates: Date[];
    times?: [Date, Date];
    theatres: Theatre[];
    hideFilters?: string[];
  };

  const { dates, theatres, times, hideFilters }: Props = $props();

  const dateOptions = dates.map(date => {
    const day = date.toLocaleDateString('en-UK', { day: 'numeric' });
    const weekday = date.toLocaleDateString('en-UK', { weekday: 'short' });
    const month = date.toLocaleDateString('en-UK', { month: 'long' });

    return {
      value: date.getTime(),
      label: `${weekday} ${day} ${month}`
    };
  });

  const theatreOptions = theatres.map(theatre => ({
    value: theatre.id,
    label: theatre.name
  }));

  const keynoteTheatreIndex = theatreOptions.findIndex(theatre => theatre.label.toLowerCase().includes('keynote'));
  if (keynoteTheatreIndex > -1) {
    const [keynoteTheatre] = theatreOptions.splice(keynoteTheatreIndex, 1);
    theatreOptions.unshift(keynoteTheatre);
  }

  const handleTimeChange = (value: [Date, Date]) => {
    filtersService.filters.times = value;
  };

  const handleDateChange = (value: number[]) => {
    const dates = value.map(v => new Date(v));

    filtersService.filters.dates = dates;
  };

  const handleTheatreChange = (value: number[]) => {
    filtersService.filters.theatres = value;
  };

  const handleClearFilters = (e: MouseEvent) => {
    e.preventDefault();

    filtersService.clear();
  };
</script>

<div class="bg-blue">
  <div class="p-5 py-4 !m-0 h6 !text-[1.1rem] text-pink font-black">
    Refine
  </div>
  <div class="px-5 pb-7">
    <SearchInput
      value={filtersService.filters.search || ''}
      onchange={(value) => filtersService.filters.search = value}
    />
  </div>
  <div class="flex flex-col gap-7 px-5 pb-7">
    {#if dateOptions.length > 0 && !hideFilters?.includes('dates')}
      <MultiCheckboxInput
        name="dates"
        options={dateOptions}
        value={filtersService.filters.dates?.map(date => date.getTime()) || []}
        label="Date"
        onchange={handleDateChange}
      />
    {/if}
    {#if times?.length && times.length === 2 && !hideFilters?.includes('times')}
      <TimeRangeInput
        label="Time"
        min={times[0]}
        max={times[1]}
        value={filtersService.filters.times}
        onchange={handleTimeChange}
      />
    {/if}
    {#if theatreOptions.length > 0 && !hideFilters?.includes('theatres')}
      <MultiCheckboxInput
        name="theatres"
        options={theatreOptions}
        value={filtersService.filters.theatres || []}
        label="Theatres"
        onchange={handleTheatreChange}
      />
    {/if}
  </div>
  <button onclick={handleClearFilters} class="bg-pink p-5 py-3 !m-0 h6 !text-[1.1rem] font-black w-full text-left">
    Clear filters
  </button>
</div>